module.exports = __webpack_public_path__ + "assets/img/browse_label.4ed138d3.png";